import { getEnvVar } from '../vite-config';

const isLocal = (): boolean => {
  return getEnvVar('VITE_IS_LOCAL') === 'true';
};

const useIsLocal = (): boolean => {
  return isLocal();
};

export { isLocal, useIsLocal };
